module.exports = __webpack_public_path__ + "img/FIN_DM.b0e5c9b5.png";